define((require) => {
    "use strict";

    const Class = require("shared/util/Class");
    const ContentQuery = require("data/ContentQuery");

    /**
     * A wrapper for ContentQuery Sorting items.
     *
     * @class Sorting
     */
    return Class.extend("Sorting", {
        constructor: function(value, queryItems) {
            let query = ContentQuery.sort();
            queryItems.forEach((queryItem) => {
                // The query method takes care of defaults
                let {name, direction} = queryItem;
                // If we passed in parameterized queryItem use that.
                name = name || queryItem;
                query = query.field(name, direction);
            });

            this.value = value;
            this.query = query;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/dashboard/Sorting.js